/**
 * Reports show the portal user id (companyLogin.userIdNumber) in the "Login Id" column.
 *
 * Policies entered through the "Select LoginId" dropdown store loginIdFull as
 * `${userIdNumber}-${userName}` (that is how loginPortal is built in the backend), so the
 * user-name suffix has to be removed before it is shown.
 *
 * Bulk-uploaded policies (Shriram etc.) store the raw User ID from the Excel instead, and
 * that id can itself contain a dash - e.g. "LC288-474". Cutting at the last "-" turned it
 * into "LC288" and lost part of the login id.
 *
 * So the suffix is removed only when it really matches the policy user's name (or one of
 * the shared-login names companyLogin uses in place of a user). Otherwise the login id is
 * kept exactly as stored.
 */

// companyLogin.userId can be the string "All" / "Admin" for shared logins
const SHARED_LOGIN_NAMES = ["All", "Admin"];

export const formatLoginIdForReport = (loginIdFull, userName) => {
  const loginId = (loginIdFull ?? "").toString().trim();
  if (!loginId) {
    return "";
  }

  const suffixes = [userName, ...SHARED_LOGIN_NAMES]
    .map((name) => (name ?? "").toString().trim())
    .filter(Boolean)
    .map((name) => `-${name}`.toUpperCase());

  const upperLoginId = loginId.toUpperCase();
  const matchedSuffix = suffixes.find((suffix) => upperLoginId.endsWith(suffix));
  if (!matchedSuffix) {
    return loginId;
  }

  const trimmed = loginId.slice(0, loginId.length - matchedSuffix.length);
  return trimmed || loginId;
};
